<template>
  <MainLayout
    class="search py-4"
    v-infinite-scroll="loadMore"
    :infinite-scroll-disabled="loading"
    infinite-scroll-distance="10"
  >
    <template v-slot:extension v-if="showExtension">
      <SearchBox
        class="hidden-md-and-up"
        :placeholder="$t('SEARCH.PLACEHOLDER_CTA')"
        />
    </template>

    <h1>{{ $t('SEARCH.TITLE') }}</h1>

    <div
      v-if="!loading && $store.state.search.list.length === 0"
      class="text-center mt-12"
    >
      <h3>{{ $t('SEARCH.NO_RESULTS.TITLE') }}</h3>
      <p>{{ $t('SEARCH.NO_RESULTS.DESCRIPTION') }}</p>
    </div>
    <v-row v-else>
      <v-col
        v-for="(item, i) in $store.state.search.list"
        :key="i"
        cols="12"
        md="4"
      >
        <SearchItem
          :pic="item.debunk_image"
          :title="item.title"
          :url="item.redirect_url"
        />
      </v-col>
    </v-row>

    <SearchSkeletons
      v-if="loading"
      :number="countSkeletons"
    />
  </MainLayout>
</template>

<!-- repeated in home for home container, move to global? -->
<style scoped>
  .search {
    background: rgb(249,249,249);
    background: linear-gradient(0deg, rgba(249,249,249,1) 0%, rgba(255,255,255,1) 100%);
  }
</style>

<script>
// @ is an alias to /src
import MainLayout from '@/layouts/MainLayout.vue';

import SearchSkeletons from '@/components/search/SearchSkeletons.vue';
import SearchBox from '@/components/search/SearchBox.vue';
import SearchItem from '@/components/search/SearchItem.vue';

const MOBILE_SKELETON_COUNT = 2;
const MEDIUM_SKELETON_COUNT = 6;

export default {
  name: 'Search',
  components: {
    MainLayout,
    SearchSkeletons,
    SearchBox,
    SearchItem,
  },
  // data: () => ({
  // }),
  computed: {
    showExtension() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    countSkeletons() {
      return this.$vuetify.breakpoint.smAndDown ? MOBILE_SKELETON_COUNT : MEDIUM_SKELETON_COUNT;
    },
    loading() {
      return this.$store.state.search.loading;
    },
  },
  methods: {
    loadMore() {
      if (!this.$store.state.search.lastPage) {
        this.$store.dispatch('search/loadMore');
        this.$track('search_more', 'search', this.$store.state.search.query);
      }
    },
  },
  created() {
    if (this.$store.state.search.list.length === 0) {
      this.$store.dispatch('search/get');
    }

    // On first play, show tutorial
    const showTutorial = !this.$store.state.settings.preEvaluatedSearch;

    if (!this.isClassMode && showTutorial) {
      this.$router.replace({ name: 'searchTutorial' });
    }
  },
};
</script>
